namespace AgerLMS {
    export interface UserItem {
        UserGroup?: UserGroups;
        DisplayName?: string;
        Email?: string;
        ProfileUrl?: string;
        Bio?: string;
        JobTitle?: string;
        UserId?: number;
        ItemCoverImage?: string;
        ItemThumbnailImage?: string;
    }
}
